import React from 'react';
import { TILE_TYPES } from './constants/gameConstants';

const Tile = ({ type, row, col, onDragStart, onDrop, onDragOver, gameStarted, onBunnyClick }) => {
  // Determine if the tile is draggable
  const draggable = gameStarted && (type === TILE_TYPES.PATH || type === TILE_TYPES.WALL);
  const isFixed = type === TILE_TYPES.FIXED;
  const isBunny = type === TILE_TYPES.BUNNY;

  // Base Tailwind CSS classes for all tiles
  let tileClasses = `
    w-12 h-12 border border-gray-600 box-border
    flex items-center justify-center text-xl font-bold
    transition-colors duration-300 ease-in-out
    rounded-md
  `;

  // Apply specific classes based on tile type
  switch (type) {
    case TILE_TYPES.EMPTY:
    tileClasses += ' bg-white';
      break;
    case TILE_TYPES.WALL:
      tileClasses += ' bg-green-400 cursor-grab';
      break;
    case TILE_TYPES.PATH:
      tileClasses += ' bg-green-500 cursor-grab';
      break;
    case TILE_TYPES.BUNNY:
      tileClasses += ' bg-pink-400 bg-contain bg-no-repeat bg-center cursor-pointer';
      // Using Twemoji for bunny icon
      tileClasses += ' bg-[url("https://twemoji.maxcdn.com/v/latest/72x72/1f430.png")]';
      break;
    case TILE_TYPES.EXIT:
      tileClasses += ' bg-violet-200';
      break;
    case TILE_TYPES.MONSTER:
      tileClasses += ' bg-red-300 bg-contain bg-no-repeat bg-center';
      // Using Twemoji for monster icon
      tileClasses += ' bg-[url("https://twemoji.maxcdn.com/v/latest/72x72/1f47e.png")]';
      break;
    case TILE_TYPES.FIXED:
      tileClasses += ' bg-gray-500 text-gray-900';
      break;
    default:
      tileClasses += ' bg-gray-700'; // Default for unknown types
  }

  return (
    <div
      className={tileClasses}
      draggable={draggable && !isFixed && !isBunny}
      onDragStart={e => draggable && !isFixed && !isBunny && onDragStart(e, row, col)}
      onDrop={e => !isFixed && !isBunny && onDrop(e, row, col)} // Allow dropping on empty/path/wall
      onDragOver={e => !isFixed && !isBunny && onDragOver(e)} // Allow dragging over empty/path/wall
      onClick={() => !isFixed && onBunnyClick && onBunnyClick(row, col)}
    >
        {isBunny && <span className="text-white">🐰</span>} {/* Render bunny icon */}
        {type === TILE_TYPES.MONSTER && <span className="text-white">👾</span>} {/* Render monster icon */}
     {isFixed &&  <span className="text-red-400 font-bold">X</span> } {/* Render 'X' for fixed tiles */}
    {type === TILE_TYPES.EXIT && <span className="text-white">🏠</span>} {/* Render home icon */}
    </div>
  );
};

export default Tile;
